import { ArrowDown } from 'lucide-react';
import { AnimatePresence, motion } from 'motion/react';
import React from 'react';
import { cn } from '../../lib/utils';
import { Button } from '../ui/button';

interface ScrollToBottomButtonProps {
  isVisible: boolean;
  onClick: () => void;
  generalBackground?: string;
  textColor?: string;
}

export const ScrollToBottomButton: React.FC<ScrollToBottomButtonProps> = ({
  isVisible,
  onClick,
  generalBackground,
  textColor,
}) => {
  const buttonClasses = cn(
    'bitte-absolute bitte-bottom-2 bitte-left-1/2 bitte--translate-x-1/2 bitte-z-[99] bitte-shadow-lg hover:bitte-bg-inherit',
  );

  const iconClasses = cn('bitte-h-4 bitte-w-4');

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 10 }}
          transition={{ type: 'spring', stiffness: 300, damping: 20 }}
        >
          <Button
            size="icon"
            variant="outline"
            className={buttonClasses}
            style={{
              backgroundColor: generalBackground,
              borderRadius: '9999px',
            }}
            onClick={onClick}
          >
            <ArrowDown className={iconClasses} style={{ color: textColor }} />
          </Button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
